import * as React from "react";
import {useEffect, useRef, useState} from "react";
import {TemplatesEnum} from "../../model/enums/TemplatesEnum";
import Coverage from "../../components/Coverage";
import {values} from "../../values/coverage";
import {accident} from "../../values/accident";
import SwitchComponent from "../../components/SwitchComponent";
import moment from "moment";
import {Button, Divider, Form,} from "antd";
import {AccidentEnum} from "../../model/enums/AccidentEnum";
import PrevNextButtons from "../../components/PrevNextButtons";
import {CalcData} from "../../model/clases/CalcData";
import SelectComponent from "../../components/SelectComponent";
import DatePickerComponent from "../../components/DatepickerComponent";
import InputComponent from "../../components/InputComponent";
import {util} from "../../core/utils";
import {CameraOutlined, FileImageOutlined} from "@ant-design/icons/lib";
import {api} from "../../core/api";


interface StepOneProps {
  current: number
  steps: number
  initialData?: CalcData
  isHull: boolean;

  onReceiptChange?(file: any): void

  prev?(): void

  next(): void

  onFinish(value: any): void
}

const StepOneComponent = ({current, steps, prev, initialData, onFinish, isHull,}: StepOneProps) => {
  const [hull, setHull] = useState<boolean>(isHull);
  const [preseted, presetHull] = useState<boolean>(false);
  const [cet, setCet] = useState<string>(moment().format("YYYY-mm-dd"));
  const [accItem, setAccItem] = useState<AccidentEnum | string>(AccidentEnum.OPTION1);
  const [receiptImage, setReceiptImage] = useState<any>(initialData?.receipt ? URL.createObjectURL(initialData?.receipt): undefined);
  const [inputProps, setInputProps] = useState<any>(undefined);
  //@ts-ignore

  useEffect(() => {
    util.screen.renderOnTop();
    currentDate();
    //@ts-ignore
  }, [current,]);
  useEffect(() => {
    //@ts-ignore
  }, []);
  const subjectSelect = [
    {
      value: TemplatesEnum.BICIKLO,
      item: "Biciklo"
    },
    {
      value: TemplatesEnum.DRUGO,
      item: "Drugo"
    }
  ];
  const accidentSelect = [
    {
      value: AccidentEnum.OPTION1,
      item: "Pokriće 10.000",
    },
    {
      value: AccidentEnum.OPTION2,
      item: "Pokriće 20.000"
    }
  ];

  async function currentDate() {
    try {
      const response = await api.date.currentCET();
      setCet(response);
      console.log(moment(response))
    } catch (e) {
      console.error(e)
    }
  }

  function disabledDateHull(current: any) {
    // Can not select days after today and 7 days earlier
    return moment(cet).add(-7, 'days') >= current ||
      moment(cet).add(1, 'days') <= current;
  }

  function disabledDate(current: any) {
    // Can not select days before today and today
    return moment().add(0, 'days') >= current ||
      moment().add(30, 'days') <= current;
  }


  const normFile = (e: any) => {
    if (Array.isArray(e)) {
      return e;
    }
    console.log(e.target.files[0]);
    return e && e.target.files[0];
  };

  const inputGallery = useRef<HTMLInputElement>(null);
  return (
    <div>
      <h1>Izbor mikro prevoznog sredstva</h1>
      {/*//@ts-ignore
        !!page && page.data.config.data*/}
      <Form
        name="basic"
        onFinish={onFinish}
        style={{width: "100%"}}
        initialValues={initialData}
        scrollToFirstError={true}
      >
        <div className={"column"} style={{padding: "0 20px"}}>
          <SelectComponent
            name={"itemType"}
            label={"Vrsta MPS"}
            tooltip={"osiguranje bicikala i drugih mikro prevoznih sredstava (do 25 km/h) "}
            message={"Izaberite mikroprevozno sredstvo!"}
            required={true}
            values={subjectSelect}
            initialFieldValue={initialData?.itemType}
          />
          <SelectComponent
            name={"accident"}
            label={"Pokriće nezgode"}
            message={'Izaberite pokriće nezgode!'}
            required={true}
            values={accidentSelect}
            onChange={(e) => setAccItem(e)}
            initialFieldValue={initialData?.accident}
          />
          <DatePickerComponent
            disabledDate={disabledDate}
            name={"startDate"}
            initialFieldValue={initialData?.startDate}
            label={"Datum početka osiguranja"}
            message={"Izaberite datum početka osiguranja!"}
            required
          />
        </div>
        <div style={{backgroundColor: "#f5f5f5", padding: "0 20px"}}>
          <h1>Osiguravajuće pokriće</h1>
          <Coverage values={values.liability}/>
          <Coverage
            // @ts-ignore
            values={accident[accItem]}/>
          <SwitchComponent
            name={"hull"}
            checkDefault={hull}
            handleChange={(e) => {
              console.log(e);
              if (hull) {
                //presetHull(!hull);
                setTimeout(function () {
                  setHull(e);
                  //setHull(undefined)
                }, 600);
              } else {
                setHull(e);
                //presetHull(true)
              }
            }}
            label={<div>Kasko osiguranje mikro prevoznog sredstva</div>}
            tooltip={"Osiguranje pokriva štetu na biciklima i drugim mikro prevoznim sredstvima usled saobraćajne nesreće," +
            " požara, udara groma, eksplozije, oluje, grada, pada aviona, demonstracija i manifestacija, provalne krađe" +
            " i razbojništva i zemljotresa na teritoriji Crne Gore. Učešće osiguranika u šteti iznosi 50 €."}
          />
          {hull &&
          <div className={" " + !hull ? 'hull-show' : 'hull-hide'}>
              <DatePickerComponent
                  disabledDate={disabledDateHull}
                  name={"purchaseDate"}
                  initialFieldValue={initialData?.purchaseDate}
                  label={"Datum kupovine MPS"}
                  message={"Izaberite datum kupovine MPS"}
                  required
              />
              <InputComponent
                  name={"itemValue"}
                  initialFieldValue={initialData?.itemValue}
                  label={"Vrijednost MPS"}
                  type={"number"}
                  suffix={"EUR"}
                  tooltip={"Maloprodajna vrijednost sa računa"}
                  required
                  message={"Unos vrijednosti MPS-a je obavezan!"}
              />
              <Form.Item
                  required
                  name="receipt"
                  label="upload fiskalnog računa"
                  valuePropName="fileList"
                  getValueFromEvent={normFile}
                  extra="Prikačite jasnu sliku fiskalnog računa za predmet koji osiguravate"
              >
                  <input
                      required={!initialData?.receipt}
                      style={{position: "absolute", opacity: 0}}
                      ref={inputGallery}
                      name={'receipt'}
                      type={"file"}
                      accept={'image/*, application/pdf'}
                      onChange={(e) => {
                        e.target.files && setReceiptImage(URL.createObjectURL(e.target.files[0]))
                      }}
                      {...inputProps}/>
              </Form.Item>
            {receiptImage && <img src={receiptImage} alt={"receiptIMG"} width={100} height={"100"}/>}
              <div style={{
                display: "flex",
                flexDirection: "column",
              }}>
                  <Button className={'button-grey'} onClick={() => inputGallery.current?.click()}
                          icon={<FileImageOutlined/>}>
                      Dodaj iz galerije
                  </Button>
                  <Button className={'button-grey'} onClick={() => {
                    setInputProps({capture: "camera"});
                    inputGallery.current?.click()
                  }} icon={<CameraOutlined/>}>
                      Slikaj
                  </Button>
              </div>
          </div>
          }
          <Divider style={{margin: 0}}/>
        </div>
        <PrevNextButtons current={current} steps={steps} prev={() => prev && prev()} next/>
      </Form>
    </div>
  )
};

export default StepOneComponent;

